import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { WindowService } from "@merri/common";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { KEYWORD_SEARCH_MAX_KEYWORDS, KEYWORD_SEARCH_MAX_LENGTH } from "src/app/core";
import { SearchBarComponent } from "src/app/shared";
import { PopoverRef } from "src/app/shared/components/popover/models/popover-ref";
import { PopoverService } from "src/app/shared/components/popover/services/popover.service";
import { VisionboardAttributesService } from "../../../services";

@Component({
  selector: "app-visionboard-item-search-bar",
  templateUrl: "./visionboard-item-search-bar.component.html",
  styleUrls: ["./visionboard-item-search-bar.component.scss"],
  standalone: false,
})
export class VisionboardItemSearchBarComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();
  private showPopover$: Subject<boolean> = new Subject<boolean>();
  private popoverRef: PopoverRef;
  @ViewChild(SearchBarComponent) searchBar: SearchBarComponent;

  keyword: string;
  disabled: boolean;
  readonly maxLength = KEYWORD_SEARCH_MAX_LENGTH;
  readonly maxKeywords = KEYWORD_SEARCH_MAX_KEYWORDS;

  constructor(
    private visionboardAttributesService: VisionboardAttributesService,
    private popoverService: PopoverService,
    private _windowService: WindowService,
  ) {}

  ngOnInit(): void {
    this.visionboardAttributesService.searchKeyword$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: keyword => {
        this.keyword = keyword;
      },
    });

    this.visionboardAttributesService.currentFilters$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: () => {
        this.disabled = !this.visionboardAttributesService.attributesLoaded();
      },
    });

    this.visionboardAttributesService.filtersChanged$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: () => {
        this.showPopover$.next(false);
        this.closePopover();
      },
    });

    this.showPopover$.pipe(debounceTime(3000), takeUntil(this.destroyed$)).subscribe({
      next: show => {
        if (show && this.searchBar?.searchButton?.nativeElement && !this.popoverRef) {
          this.popoverRef = this.popoverService.open("Search Items", this.searchBar.searchButton.nativeElement);
        }
      },
    });

    this._windowService
      .observeMax$(576)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.showPopover$.next(false);
          this.closePopover();
        },
      });
  }

  onUserInteracting(keyword: string): void {
    this.visionboardAttributesService.setKeywordSearch(keyword, false);
    this.showPopover$.next(true);
    this.closePopover();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.closePopover();
  }

  onKeywordChange(keyword: string): void {
    this.visionboardAttributesService.setKeywordSearch(keyword, true);
    this.showPopover$.next(false);
    this.closePopover();
  }

  closePopover(): void {
    this.popoverRef?.close();
    this.popoverRef = null;
  }
}
